import { render, staticRenderFns } from "./ChatGPTEditorFormRowSplit.vue?vue&type=template&id=0d5744d2&"
import script from "./ChatGPTEditorFormRowSplit.vue?vue&type=script&lang=js&"
export * from "./ChatGPTEditorFormRowSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports